<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton></screenButton>
      </div>
    </div>
    <div style="padding-top: 50px;">
      <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered
               :items="items" :fields="fields">
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(place)="data" style="'left':'80px';">
          {{ data.item.meterAttribute==='1'? data.item.installationSite:data.item.houseName}}
        </template>
        <template v-slot:cell(meterAttribute)="data" style="'left':'80px';">
          {{data.item.meterAttribute==1?'不计费':data.item.meterAttribute==2?'计费预充值':'计费非预充值' }}
        </template>
        <template v-slot:cell(times)="data" style="'left':'80px';">
          {{ Number(data.item.times).toFixed(0) }}
        </template>
        <template v-slot:cell(prevReading)="data" style="'left':'80px';">
          {{Number(data.item.prevReading).toFixed(data.item.decimalPlaces) }}
        </template>
        <template v-slot:cell(lastReading)="data" style="'left':'80px';">
          {{Number(data.item.lastReading).toFixed(data.item.decimalPlaces) }}
        </template>
        <template v-slot:cell(lastQuantity)="data" style="'left':'80px';">
          {{data.item.lastQuantity?Number(data.item.lastQuantity).toFixed(data.item.decimalPlaces):'-' }}
        </template>
        <template v-slot:cell(lossRate)="data" style="'left':'80px';">
          {{ (Number(data.item.lossRate) * 100).toFixed(0) }}%
        </template>
        <template v-slot:cell(lastLossQuantity)="data" style="'left':'80px';">
          {{ Number(data.item.lastLossQuantity).toFixed(data.item.decimalPlaces)}}
        </template>
        <template v-slot:cell(totalUsage)="data" style="'left':'80px';">
          {{ data.item.lastQuantity?(Number(data.item.lastQuantity) + Number(data.item.lastLossQuantity)).toFixed(data.item.decimalPlaces):(0).toFixed(data.item.decimalPlaces)}}
        </template>
        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width:  field.key === 'index' ?'30px':'120px',left: field.key === 'materialData' ? '120px' : '80px'}"
          />
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import {BTable} from 'bootstrap-vue'


export default {
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'leasingResourcesCode', stickyColumn: true, label: '资源编号'},
        {key: 'area', label: '最终档案面积（㎡）'},
        {key: 'propertyArea', label: '租赁建筑面积（㎡）'},
        {key: 'inPropertyArea', label: '租赁套内面积（㎡）'},
        {key: 'chargingPropertyArea', label: '计费面积（㎡）'},
        {key: 'coin', label: '基准单价（元/㎡/日）'},
        {key: 'unitPrice', label: '单价（元/㎡/日）'},
      ],
      items: [],
      layoutHeight: '0px',
      time: 0
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
      let query = this.$route.query;
      this.items = query.data
    });
  },
  methods: {
    init() {
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style>
tr th:nth-child(2), tr td:nth-child(2) {
  left: 30px !important;
}
</style>
